import { Component } from '@angular/core';

interface PriceItem {
  name: string;
  price: string;
  description: string;
}

@Component({
  selector: 'app-price-list',
  standalone: true,
  templateUrl: './price-list.html',
  styleUrl: './price-list.scss',
})
export class PriceList {
  protected readonly leftItems: PriceItem[] = [
    {
      name: 'Gépi hajvágás',
      price: '4 400 Ft',
      description:
        'Ha gyors, profi és pontos munkát szeretnél, bízd az egy hosszra ' +
        'nyírást is a borbélyodra! Nekünk elhiheted, hogy a tarkódnál mi ' +
        'jobban megcsináljuk majd, mint ahogy te bármikor tudnád a ' +
        'fürdőszobatükör előtt. Kizárólag géppel, egy hosszra.',
    },
    {
      name: 'A szakáll igazítás',
      price: '5 000 Ft',
      description:
        'Válogasd meg, ki nyúlhat a szakálladhoz! Azért növesztetted ' +
        'heteken, hónapokon át, hogy az arcod ékessége legyen. Nálunk ' +
        'profik várnak arra, hogy rájuk bízd magad, és ígérjük: nem fogsz ' +
        'csalódni. Ha valaki, hát a borbélyod tudja, hogyan kell bánni a ' +
        'szakálladdal. Gépi és pengével történő igazítás.',
    },
    {
      name: 'Szakáll festés',
      price: '4 600 Ft',
      description:
        'Hajfestés vagy őszülő haj fiatalító fedése esetében érdemes ' +
        'gondoskodni a szakállról is, hogy természetes küllemű legyen az ' +
        'összhatás! Arról már nem is beszélve, hogy a legőrültebb trendek ' +
        'néha vad színű szakállt kívánnak.',
    },
    {
      name: 'Gyermek hajvágás',
      price: '5 400 Ft',
      description:
        'Konzultáció, vágás, finishing a kiválasztott termékkel. A ' +
        'borbélyt felkeresni egy nagyszerű lépés a férfivá éréshez. ' +
        'Nálunk 12 éves korig még élvezheted a gyerekeknek járó ' +
        'árkedvezményt. Viszont ha már betöltötted, akkor érett férfinak ' +
        'számítasz.',
    },
    {
      name: 'Prémium szakáll ápolás',
      price: '6 700 Ft',
      description:
        'A szakállat géppel és ollóval formázzuk a kívánt stílusban. Ezt ' +
        'követően prémium anyagok felhasználásával forró törölközős ' +
        'puhítással végezzük a kontúrozást, valamint az igazítás végén ' +
        'egy forró olajos kezeléssel kényeztetjük a szakállat. Igazi ' +
        'prémium élmény ínyenceknek.',
    },
    {
      name: 'A hajvágás',
      price: '7 300 Ft',
      description:
        'Konzultáció, vágás, finiselés a kiválasztott termékkel, ' +
        'nyakborotválás. Konzervatív vagy feltűnőbb hajak, kísérletezés ' +
        'vagy a régi, jól bevált frizurád: ha már igazán itt az ideje egy ' +
        'hajvágásnak, de még nem tudod, mit szeretnél, akkor is bízd csak ' +
        'ránk magad nyugodtan. Kitaláljuk együtt mi lenne számodra a ' +
        'legjobb választás.',
    },
  ];

  protected readonly rightItems: PriceItem[] = [
    {
      name: 'Hot towel borotválás',
      price: '8 200 Ft',
      description:
        'Igazi, tradícionális forró törölközős borotválás, egyszer ' +
        'minden férfinak ki kell próbálnia! Ellazít és felüdít, ha ' +
        'valamiért érdemes borbélyhoz menni, akkor ez az. Alapozunk, ' +
        'bebugyolálunk, picit dunsztolunk, pamacsozunk, neki esünk egy ' +
        'pengével és a végén finishelünk. Igazi borbély élmény.',
    },
    {
      name: 'Kreatív hajvágás haj tattoo',
      price: '8 700 Ft',
      description:
        'Akár az elmondásod, akár kép alapján megvalósítjuk akár a ' +
        'legvadabb elképzeléseidet (egy bizonyos határon belül). ' +
        'Borbélyaink szeretik a kihívásokat, úgyhogy ha olyan ' +
        'elképzelésed van, amelynek elkészítését rá bíznád egy ' +
        'szakemberre, keress fel vele minket bátran!',
    },
    {
      name: 'Ollós hajvágás',
      price: '10 600 Ft',
      description:
        'Ollós hajvágás során a borbély csak és kizárólag ollóval, gép ' +
        'használata nélkül dolgozik a frizurán.',
    },
    {
      name: 'Barber treatment',
      price: '11 300 Ft',
      description:
        'Ha érdekel, milyen a nagybetűs Barber Shop Életérzés, nevezz be ' +
        'egy ilyenre: levágjuk a hajad, kapsz egy forró törölközős ' +
        'borotválást (ahogy illik!), majd a végén prémium termékekkel ' +
        'elvégezzük az utolsó simításokat. Állásinterjúra, első ' +
        'randihoz, és minden olyan alkalom előtt, ahol lenyűgözni ' +
        'szeretnél. Vagy fordítsuk meg! Leborotváljuk a kobakod és rendbe ' +
        'hozzuk a rezsét az arcodon.',
    },
    {
      name: 'Hajvágás és szakáll igazítás',
      price: '11 200 Ft',
      description:
        'Karbantartjuk frizurádat és szakálladat, hogy neked ne legyen ' +
        'már rá gondod. A stílusod alapja az ápoltság, így muszáj ' +
        'rendszeresen visszajárnod, ha folyamatosan szeretnél remek ' +
        'benyomást kelteni! Oldalt rövidebbre átmenetet képezve a hajad ' +
        'és a szakálladat között plusz kontúrozunk, mosunk, finishelünk… ' +
        'Trendi, fiatalos, vagy éppen favágó stílus? Mi megoldjuk.',
    },
    {
      name: 'Apa fia hajvágás',
      price: '10 800 Ft',
      description:
        'Ez talán a kedvencünk. A borbélyszalon a férfiasság temploma, ' +
        'hol máshol tölthetnél el minőségi időt apa a fiával? 3 éves ' +
        'kisfiú vagy 80 éves úr, egyáltalán nem a kor számít, csak hogy ' +
        'ketten jöjjetek és együtt élvezzétek szakértő borbélyaink ' +
        'ápolását.',
    },
  ];
}
